<template>
  <!-- <div class="row d-none">
    <div class="col" v-if="loading">
      <div class="text-center">
        <Vue3Lottie :animationData="searchingJSON" class="height-150 py-2" />
      </div>
    </div>
    <div class="col" v-if="!loading && retailers.length == 0">
      <div class="text-center">
        <Vue3Lottie :animationData="noDataJSON" class="height-150 py-2" />
        <p class="text-xs font-weight-bold">No Data Found</p>
      </div>
    </div>
    <div class="col-md-4 mb-md-0 mb-4 mt-2" v-for="(retailer, i) in retailers" :key="i">
      <div class="card card-body border card-plain border-radius-lg"
        :class="retailer.elpRemarks != null ? 'card-disable' : ''">
        <div class="row">
          <div class="col">
            <a href="javascript:void(0)" @click="loadSubRetailer(retailer)">
              <h6 class="mb-0">
                <b>{{ retailer.name }}</b>
                <i class="fa-solid fa-arrow-right ms-2" v-if="!subRetailerLoading"></i>
                <i class="fa-solid fa-spinner fa-spin-pulse mx-1" v-if="subRetailerLoading"></i>
              </h6>
            </a>
            <hr class="horizontal dark" />
            <p title="Branch ID" class="mb-0">{{ retailer.branchID }}</p>
            <p title="Corporate ID" class="mb-0">{{ retailer.corporateID }}</p>
            <p title="Username" class="mb-0">{{ retailer.userName }}</p>
            <p title="Address" class="mb-0" style="text-transform: capitalize">
              {{ retailer.address }}
            </p>
          </div>
          <div class="col d-flex flex-column justify-content-between text-right" style="min-height: 100%;">
            <div>
              <i @click="editRetailer(retailer)" v-if="!subRetailerLoading"
                class="fas fa-pencil-alt text-dark cursor-pointer" title="Edit Card"></i>
              <h4 class="mb-0 mt-4">
                &#8369; {{ retailer.balance.toLocaleString("en") }}
              </h4>
              <h5 class="mb-0 text-xs">
                Earmarked:
                <em>&#8369; {{ retailer.earmarked.toLocaleString("en") }}</em>
              </h5>
              <p class="mb-0 mt-3 text-danger">
                <em>{{ retailer.elpRemarks }}</em>
              </p>
            </div>

          
            <div class="mt-auto text-end">
              <small @click="topUpRetailer(retailer)" v-if="!subRetailerLoading"
                class="text-dark cursor-pointer d-inline-flex align-items-center" title="Top Up Balance">
                <i class="fa-solid fa-circle-plus me-1"></i>
                Top Up Balance
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <div>
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col" v-if="loading">
            <div class="text-center">
              <Vue3Lottie
                :animationData="searchingJSON"
                class="height-150 py-2"
              />
            </div>
          </div>
          <div class="col" v-if="!loading && retailers.length == 0">
            <div class="text-center">
              <Vue3Lottie :animationData="noDataJSON" class="height-150 py-2" />
              <p class="text-xs font-weight-bold">No Data Found</p>
            </div>
          </div>
        </div>
        <div class="flex-handling">
        <div
          class=""
          v-for="(retailer, i) in retailers"
          :key="i"
        >
          <div
            class="card-new"
            :class="retailer.elpRemarks != null ? 'card-disable' : ''"
          >
            <div class="upper-section">
              <div class="d-flex align-items-center">
                <p class="mb-0 p-0 font-weight-bold text-dark">{{ retailer.name }}</p>
                <a href="javascript:void(0)" @click="loadSubRetailer(retailer)">
                  <h6 class="mb-0">
                    <i
                      class="fa-solid fa-arrow-right ms-2"
                      v-if="!subRetailerLoading"
                    ></i>
                    <div
                      class="spinner-border spinner-border-sm"
                      role="status"
                      v-if="subRetailerLoading"
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                  </h6>
                </a>
              </div>
              <div class="d-flex">
                <!-- <div class="icon-container">
                  <img src="/img/transaction.png" alt="logo" />
                </div> -->
                <div
                  class="icon-container"
                  @click="editRetailer(retailer)"
                  v-if="!subRetailerLoading"
                >
                  <img src="/img/update.png" alt="logo" />
                </div>
              </div>
            </div>
            <div class="body-section">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="mb-0 p-0 ">Representative: {{ retailer.representative }}</p>
                  <hr class="bg-dark w-100" />
                </div>
                <div class="text-end">
                  <!-- <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p> -->
                  <!-- <h6 class="mb-0 card-text-dark">
                    Php {{ retailer.balance.toLocaleString("en") }}
                  </h6> -->
                   <h6 class="mb-0 card-text-dark">
                      <template v-if="subRetailerLoading">
                        <p class="placeholder-glow mb-0">
                        <span class="placeholder col-12"></span>
                      </p>
                      </template>
                      <template v-else>
                        Php {{ retailer.balance.toLocaleString("en") }}
                      </template>
                    </h6>
                  <small class="text-muted">Wallet Balance</small>
                </div>
              </div>
              <div class="d-flex justify-content-between">
                <p class="mb-0 p-0">{{ retailer.dealerType }}</p>
                <p class="mb-0 p-0">
                  Earmarked :
                  <span class="card-text-dark">
                    Php {{ retailer.earmarked.toLocaleString("en") }}</span
                  >
                </p>
              </div>
              <p class="mb-0 p-0">{{ retailer.email }}</p>
              <p class="mb-0 p-0">{{ retailer.companyAddress }}</p>
              <div class="d-flex justify-content-between">
                <p class="mb-0 p-0"></p>
                <div
                  class="icon-container text-dark"
                  @click="topUpRetailer(retailer)"
                  v-if="!subRetailerLoading"
                >
                  <img src="/img/top-up.png" class="" alt="logo" /> Top Up
                  Balance
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import noDataJSON from "./../../../../assets/no-data.json";
import searchingJSON from "./../../../../assets/searching.json";

export default {
  data() {
    return {
      noDataJSON,
      searchingJSON,
    };
  },
  computed: {
    ...mapState({
      loading: (state) => state.retailerController.loading,
      retailers: (state) => state.retailerController.filteredRetailers,
      subRetailerLoading: (state) =>
        state.retailerController.subRetailerLoading,
    }),
  },
  methods: {
    ...mapActions({
      getRetailers: "retailerController/GetRetailers",
      getSubRetailers: "retailerController/GetSubRetailers",
    }),
    ...mapMutations({
      setShowRetailerTopUpSidebar:
        "retailerController/SET_ShowRetailerTopUpSidebar",
      selectRetailer: "retailerController/SELECT_Retailer",
      toggleShowRetailerSidebar:
        "retailerController/TOGGLE_ShowRetailerSidebar",
    }),
    async loadSubRetailer(retailer) {
      this.selectRetailer(retailer);
        await this.getSubRetailers(); //tech debt - duplicate calling when master dealer, low prio (very minor perframance cost)
    },
    editRetailer(retailer) {
      this.selectRetailer(retailer);
      this.toggleShowRetailerSidebar(true);
    },
    topUpRetailer(retailer) {
      //alert("not yet implemented.");
      this.selectRetailer(retailer);
      this.setShowRetailerTopUpSidebar(true);
    },
  },
  async mounted() {
    await this.getRetailers();
  },
};
</script>

<style></style>
